import { PromoCardProps } from '../interface/interface';
import { Naturopath_url } from './constant';

export const promoCards: PromoCardProps[] = [
  {
    eyebrow: 'Personalised Wellness Support',
    heading: 'Guidance for a healthier you',
    description:
      'Book a complimentary consultation with our qualified naturopath and get personalised recommendations for your health goals.',
    buttonLabel: 'Book A Consultation →',
    buttonHref: Naturopath_url,
    imageSrc: '/banners/naturopath-consultation.png',
    imageAlt:
      'A naturopath in a white coat smiling while consulting with a patient.',
    variant: 'cool',
  },
  {
    eyebrow: 'Everyday Energy & Wellbeing',
    heading: 'Elevate Your Daily Routine',
    description:
      "Add Life Cykel Lion's Mane to coffee, smoothies, tea or water - an easy addition to your everyday wellness routine.",
    buttonLabel: 'Shop Life Cykel Range →',
    buttonHref: '/guest/shop-non-script',
    imageSrc: '/banners/lifecykel-product.png',
    imageAlt:
      'Herbs of Gold Activated B Complex bottle beside a man enjoying the outdoors.',
    variant: 'warm',
  },
];
